module.exports = __webpack_public_path__ + "img/mh_logo.71d80ebf.png";